// ContactPage.js

import React from "react";
import { Helmet,HelmetProvider } from "react-helmet-async";
import MainLayout from "../Layouts/MainLayout";
import "../CSS/ContactPage.css";

const ContactPage = () => {
  return (
    <MainLayout>
      <HelmetProvider>
      <Helmet>
        <title>Contact Us - BlogWiki</title>
        <meta
          name="description"
          content="Contact BlogWiki for any questions, feedback, or inquiries. We'd love to hear from you!"
        />
      </Helmet>
      </HelmetProvider>
      <div className="contact-page">
        <h1>Contact Us</h1>
        <p>
          We'd love to hear from you! Feel free to reach out to us with any
          questions, feedback, or inquiries you may have.
        </p>
        <form className="contact-form">
          <label htmlFor="name">Name:</label>
          <input type="text" id="name" name="name" />
          <label htmlFor="email">Email:</label>
          <input type="email" id="email" name="email" />
          <label htmlFor="message">Message:</label>
          <textarea id="message" name="message" rows="5"></textarea>
          <button type="submit">Send</button>
        </form>
      </div>
    </MainLayout>
  );
};

export default ContactPage;
